import { fetch } from '@/utils/fetch';

export function _queryGoodsSeriesGathers(
  {
    page, size, direction, sort, seriesId,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      seriesId,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsSeriesGather(gatherId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${gatherId}`,
    method: 'get',
  });
}

/**
 * 新增
 */
export function _addGoodsSeriesGather(
  {
    seriesId,
    coverPath,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather`,
    method: 'post',
    data: {
      seriesId,
      coverPath,
    },
  });
}

/**
 * 更新
 */
export function _updateGoodsSeriesGather(gatherId, {
  coverPath,
  seriesId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${gatherId}`,
    method: 'patch',
    data: {
      coverPath,
      seriesId,
    },
  });
}

export function _updateGoodsSeriesGatherGoods(goodsSeriesId, {
  goodsId,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${goodsSeriesId}/goods`,
    method: 'post',
    data: {
      goodsId,
    },
  });
}

/**
 * 删除
 * @param goodsSeriesId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsSeriesGather(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${goodsSeriesId}`,
    method: 'delete',
  });
}

export function _deleteGatherGoods(gatherId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${gatherId}`,
    method: 'delete',
  });
}

/**
 * 拖拽排序
 * @param {} param0
 * @returns
 */
export function _updateGoodsSort({ idStr, sortStr, oldIndex, newIndex }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/series-gather/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}

/**
 * 上移
 * @param seriesGatherId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upWebsiteSeriesGather(seriesGatherId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${seriesGatherId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param seriesGatherId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downWebsiteSeriesGather(seriesGatherId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-gather/${seriesGatherId}/down`,
    method: 'patch',
  });
}
